<template>
  <div class="box">
    <div class="task-top">
      <span class="title-task">每日签到，领取书币，免费看书</span>
      <div class="sign-tag">
        <img class="sign-tag-image" src="../../static/smile.png" alt="" />
        <span class="sign-tag-text">已连续签到 {{ dayNum }} 天</span>
      </div>
      <div class="day-box">
        <div class="day-item" v-for="(item, index) in dayList" :key="index">
          <div
            class="day-item-content"
            :class="dayNum >= index + 1 ? 'day-item-content-active' : ''"
          >
            <img class="day_star" src="../../static/unsign.png" alt="" />
            <span
              class="day-item-content-text"
              >{{ index >5 ?  "神秘礼" : item.currency + "币" }}</span
            >
          </div>
          <span class="day-item-text">{{index>5?'≥7':index+1}}天</span>
        </div>
      </div>
      <div class="btn">
        <img
          v-if="!isSign"
          @click="signClick"
          class="sign-button"
          src="../../static/sign-click.png"
          alt=""
        />
        <img
          v-else
          @click="signClick"
          class="sign-button-default"
          src="../../static/sign-clicked.png"
          alt=""
        />
        <img
          v-if="!isSign"
          class="sign-point"
          src="../../static/sign-point.png"
          alt=""
        />
      </div>
    </div>
    <uniActivity ref="child" :showSetting="2"></uniActivity>
    <div>
      <span class="tips">签到，任务获得的书币有效期为{{ dictValue }}天</span>
      <!-- 每日任务 -->
      <div class="every-task">
        <div class="task_content">
          <span
            @click="changeTask(0)"
            class="task-title"
            :class="tabIndex == 0 ? 'task-active' : ''"
            >每日任务
          </span>
          <span
            @click="changeTask(1)"
            class="task-title"
            :class="tabIndex == 1 ? 'task-active' : ''"
            >新手任务
          </span>
        </div>
        <div
          class="task-item"
          v-for="(item, index) in TaskList"
          :key="index"
          v-if="tabIndex == 0"
        >
          <div class="task-item-left">
            <div class="task-item-top">
              <span class="sign-title">{{ item.title }}</span>
              <img
                class="task-item-top-image"
                src="../../static/unsign.png"
                alt=""
              />
              <span class="sign_currency">+{{ item.currency }}</span>
            </div>
            <span class="task-tips" v-if="item.type == 2">{{ item.tips }}</span>
            <div class="task-tips" v-if="item.type == 1 || item.type == 3">
              <span>完成</span><span class="task-num"> {{ item.text }}</span
              ><span>{{ item.type == 1 ? "分钟" : "章" }}</span>
            </div>
            <!-- <div class="task-tips" v-if="item.type == 3">
              <span>完成</span><span class="task-num"> {{ item.text }}</span
              ><span>章</span>
            </div> -->
          </div>
          <span
            @click="goTask(item)"
            class="task-btn"
            :class="item.status == 2 ? 'defaul-btn' : ''"
            >{{ item.statusText }}</span
          >
        </div>
        <div
          class="task-item"
          v-for="(item, index) in NewTask"
          :key="index"
          v-if="tabIndex == 1 && item.type != 4 && item.type != 7"
        >
          <div class="task-item-left">
            <div class="task-item-top">
              <span class="sign-title">{{ item.title }}</span>
              <img
                class="task-item-top-image"
                src="../../static/unsign.png"
                alt=""
              />
              <span class="sign_currency">+{{ item.currency }}</span>
            </div>
            <span class="task-tips">{{ item.tips }}</span>
          </div>
          <span
            class="task-btn"
            @click="goTask(item)"
            :class="item.status == 2 ? 'defaul-btn' : ''"
            >{{ item.statusText }}</span
          >
        </div>
      </div>
    </div>
    <!-- 签到成功弹窗 -->
    <div class="sign_mask" v-if="showSign">
      <img class="sign_mask_image" src="../../static/sign-success.png" alt="" />
      <span class="sign_mask_text">恭喜您获得{{ currencySign }}书币</span>
    </div>
    <!--  v-if="isNewMask"-->
    <div class="sign_mask_new" v-if="isNewMask"  >
      <div class="mask-white">
        <div class="mask-bg">
          <div class="sign-top">恭喜您获得{{ currencySign }}书币</div>
          <div class="sign-content">
            <p>- 热门书籍推荐 -</p>
            <div>
              <img :src="bookInfo.bookLogoUrl" alt="">
              <div>
                <p>{{bookInfo.bookName}}</p>
                <p>{{bookInfo.bookSummary}}</p>
              </div>
            </div>
            <div class="btn-red" @click="goRead">立即阅读</div>
          </div>
        </div>
       <div class='mask-close'>
          <img @click="closeMask" src="../../static/close-x.png" alt="" />
       </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import uniActivity from "../view/components/activity-swiper.vue";
export default {
  components: {
    uniActivity,
  },
  data() {
    return {
      bookInfo:{
            bookLogoUrl:'',
            bookSummary:'',
            bookId:'',
            bookName:''
      },
       isNewMask:false,
      showSign: false,
      dayList: [],
      isSign: false,
      TaskList: [],
      NewTask: [],
      dayNum: [],
      singnIndex: 0,
      currencySign: 0,
      pageType: "",
      tabIndex: 0,
      dictValue: 0,
     
    };
  },
  mounted() {},
  methods: {
    getCurrencyValidity() {
      this.$api.getCurrencyValidity().then((res) => {
        if (res.status == 1) {
          this.dictValue = res.data.welfareCurrency.dictValue;
        }
      });
    },
    contentFun() {
      var isNewUser = this.$base.getStorage("isNewUser");
      if (isNewUser == 1) {
        this.tabIndex = 1;
      } else {
        this.tabIndex = this.$base.getStorage("taskIndex")
          ? this.$base.getStorage("taskIndex")
          : 0;
      }
      this.taskCenter();
      this.getCurrencyValidity();
      this.insertPageAccessData();
      this.$refs.child.findRechargeActivity();
    },
    compare(arg) {
      return function (a, b) {
        return a[arg] - b[arg];
      };
    },
    insertPageAccessData() {
      var params = {
        pageName: "福利",
        pageRemark: "",
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    changeTask(index) {
      //切换每日任务和新手任务
      this.tabIndex = index;
      this.$base.setStorage("taskIndex", index);
    },
    taskCenter() {
      var params = {};
      this.$api.taskCenter(params).then((res) => {
        if (res.status == 1) {
          this.dayList = res.data.signDatas;
          res.data.dailyTaskDatas = res.data.dailyTaskDatas.sort(
            this.compare("status")
          );
          res.data.newbieTaskDatas = res.data.newbieTaskDatas.sort(
            this.compare("status")
          );
          this.TaskList = res.data.dailyTaskDatas;
          this.NewTask = res.data.newbieTaskDatas;
          this.isSign = res.data.isSign;
          this.dayNum = res.data.signDays;
          for (var i = 0; i < this.TaskList.length; i++) {
            //status==0.未完成任务，1.已完成任务还没有领取，2.已领取  type:1.充值赠礼 2.阅读分钟 3..购买回馈 4.添加桌面 5.绑定手机 6.新手阅读奖励
            if (this.TaskList[i].status == 0) {
              if (this.TaskList[i].type == 2) {
                this.TaskList[i].statusText = "去充值";
              } else if (
                this.TaskList[i].type == 1 ||
                this.TaskList[i].type == 6 ||
                this.TaskList[i].type == 3
              ) {
                this.TaskList[i].statusText = "去阅读";
              } else if (this.TaskList[i].type === 4) {
                this.TaskList[i].statusText = "去添加";
              } else if (this.TaskList[i].type == 5) {
                this.TaskList[i].statusText = "去绑定";
              } else if (this.TaskList[i].type == 7) {
                this.TaskList[i].statusText = "去设置";
              }
            } else if (this.TaskList[i].status == 1) {
              this.TaskList[i].statusText = "领取";
            } else if (this.TaskList[i].status == 2) {
              this.TaskList[i].statusText = "已领取";
            }
          }
          for (var f = 0; f < this.NewTask.length; f++) {
            //status==0.未完成任务，1.已完成任务还没有领取，2.已领取  type:1.充值赠礼 2.阅读分钟 3..购买回馈 4.添加桌面 5.绑定手机 6.新手阅读奖励
            if (this.NewTask[f].status == 0) {
              if (this.NewTask[f].type == 2) {
                this.NewTask[f].statusText = "去充值";
              } else if (
                this.NewTask[f].type == 1 ||
                this.NewTask[f].type == 3 ||
                this.NewTask[f].type == 6
              ) {
                this.NewTask[f].statusText = "去阅读";
              } else if (this.NewTask[f].type == 4) {
                this.NewTask[f].statusText = "去添加";
              } else if (this.NewTask[f].type == 5) {
                this.NewTask[f].statusText = "去绑定";
              } else if (this.NewTask[f].type == 7) {
                this.NewTask[f].statusText = "去设置";
              }
            } else if (this.NewTask[f].status == 1) {
              this.NewTask[f].statusText = "领取";
            } else if (this.NewTask[f].status == 2) {
              this.NewTask[f].statusText = "已领取";
            }
          }
        }
      });
    },
    signClick() {
      if (!this.isSign) {
        let now = new Date().valueOf();
        if (now - this.singnIndex > 2000) {
          this.singnIndex = now;
          this.$api.signIn().then((res) => {
            if (res.status == 1) {
              this.currencySign = res.data.signBookCurrency;
              if(res.data.bookId){
                this.bookInfo.bookId=res.data.bookId;
                this.bookInfo.bookName=res.data.bookName;
                this.bookInfo.bookSummary=res.data.bookSummary;
                this.bookInfo.bookLogoUrl=res.data.bookLogoUrl;
                this.isNewMask=true;
              }else{
                this.showSign = true;
                setTimeout(() => {
                this.showSign = false;
              }, 2000);
              }
              this.isSign = true;
              this.dayNum++;
              this.$base.setStorage("isSign", 1);
            } else {
              Toast({
                message: res.message,
              });
            }
          });
        }
      }
    },
    closeMask(){
          this.isNewMask=false;
    },
    goRead(){//立即阅读
          this.$router.push({
        path: "/pages/bookRead/index",
        query: {
          bookid: this.bookInfo.bookId,
          pageType: "bookTask",
        },
      });
    },
    goTask(item) {
      if (item.status === 1) {
        //领取奖励
        var params = {
          taskId: item.id,
        };
        this.$api.sendEarnPoint(params).then((res) => {
          if (res.status == 1) {
            item.status = 2;
            item.statusText = "已领取";
            this.currencySign = item.currency;
            this.showSign = true;
            setTimeout(() => {
              this.showSign = false;
            }, 2000);
            this.taskCenter();
            this.getUserCurrency();
          } else {
            Toast({
              message: res.data.message,
            });
          }
        });
      } else if (item.status == 0) {
        if (item.type === 2) {
          //充值
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              pageType: "bookTask",
            },
          });
        } else if (item.type === 1 || item.type === 3 || item.type === 6) {
          this.$emit("eventTab", {
            data: 1,
          });
        } else if (item.type === 5) {
          this.$router.push({
            path: "/pages/bookPhone/index",
            query: {
              pageType: "bookTask",
            },
          });
        }
      }
    },
    getUserCurrency() {
      //获取当前用户书币
      this.$api.getUserCurrency().then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("currency", res.data);
        }
      });
    },
  },
};
</script>
<style scoped>
.sign_mask_new {
  width: 100%;
  height: 100%;
  background-color: rgba(45,45,45,0.78);
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 99;
}
.mask-white {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.mask-white >.mask-close{
   width: 36px;
  height: 36px;
  display: block;
  margin: 0 auto;
  padding-top: 6px;
  box-sizing: border-box;
   margin-top: 18px;
}
.mask-white >.mask-close> img {
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 auto;
}
.mask-bg {
  background: #fff9f9;
  width: 240px;
  height: 246px;
  margin: 0 auto;
}
.sign-top {
  height: 59px;
  width: 100%;
  background-image: url(../../static/sign-bg.png);
  background-size: cover;
  font-size: 21px;
  color: #ffffff;
  line-height: 59px;
  text-align: center;
}
.sign-content>p{
font-size: 12px;
color: #E72828;
text-align: center;
margin:10px auto;
}
.sign-content>div{
  display: flex;
  justify-content: space-between;
  padding:0px 12px;
}
.sign-content>div>img{
   width:60px;
   height: 80px;
   border-radius: 5px;
    margin-right:10px;
}
.sign-content>div>div>p:nth-of-type(1){
  font-size: 14px;
color: #333333;
overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
  line-height: 20px;
  width: 146px;
  margin-bottom: 8px;
}
.sign-content>div>div>p:nth-of-type(2){
  font-size: 12px;
color: #666666;
 overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 18px;
  width: 146px;
}
.sign-content>.btn-red{
  display: block;
  background: #F74139;
border-radius: 100px;
font-size: 14px;
color: #FFFFFF;
width: 216px;
height: 32px;
text-align: center;
line-height: 32px;
margin:0 auto;
padding:0px;
margin-top: 20px;
}
.box {
  padding: 24px 16px;
}

.task-top {
  background: #de3b34;
  border-radius: 15px;
  padding: 20px 19px;
  padding-bottom: 5px;
}

.title-task {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}

.sign-tag {
  display: flex;
  margin-top: 4px;
  margin-bottom: 12px;
}

.sign-tag > .sign-tag-image {
  width: 17px;
  height: 17px;
  margin-right: 4px;
}

.sign-tag > .sign-tag-text {
  font-size: 12px;
  color: #ffdb00;
}

.day-box {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}

.day-item {
  text-align: center;
  width: 38px;
}

.day-item > .day-item-text {
  font-size: 12px;
  color: #ffffff;
  margin-top: 4px;
}

.day_star {
  width: 20px;
  height: 20px;
  display: block;
  margin: 0 auto;
}

.day-item-content {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  padding: 8px 0px;
}

.day-item-content-active {
  background-color: #feda00;
}

.day-item-content > .day-item-content-text {
  font-size: 12px;
  text-align: center;
  color: #ffffff;
}

.day-item-content-active .day-item-content-text {
  color: #333333;
}

.btn {
  position: relative;
  width: 250px;
  margin: 0 auto;
  margin-top: 12px;
}

.sign-button {
  width: 250px;
  height: 70px;
  display: block;
}

.sign-button-default {
  width: 250px;
  height: 56px;
  margin-bottom: 15px;
}

.sign-point {
  width: 47px;
  height: 50px;
  position: absolute;
  right: 0px;
  bottom: -5px;
  animation-name: Go;
  animation-duration: 500ms;
  animation-iteration-count: 10000;
}

@keyframes Go {
  0% {
    transform: rotate(0deg);
  }

  75% {
    transform: rotate(25deg);
  }

  100% {
    transform: rotate(0deg);
  }
}



.task-title {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  margin-bottom: 16px;
  margin-top: 20px;
}

.task-title > .task-title-span {
  font-size: 12px;
  color: #aaaaaa;
  margin-left: 8px;
  font-weight: normal;
}

.task-item {
  background-color: #f3f3f3;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  margin-bottom: 12px;
}

.task-item-top {
  display: flex;
  margin-bottom: 9px;
}

.task-item-top > .sign-title,
.task-item-top > .sign_currency {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  margin-top: 1px;
  font-weight: bold;
}
.task-item-top > .task-item-top-image {
  width: 20px;
  height: 20px;
  margin-left: 12px;
  margin-right: 4px;
}

.task-item-top > .sign_currency {
  color: #FEAF10;
  font-weight: bold;
  line-height: 20px;
  /* margin-top: 1px; */
}

.task-tips {
  font-size: 12px;
  color: #4F4F4F;
}

.task-num {
  color: #de3b34;
}

.task-btn {
  background: #de3b34;
  border-radius: 20px;
  font-size: 12px;
  color: #ffffff;
  width: 62px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  margin-top: 10px;
}

.defaul-btn {
  background: #dddddd;
}

.sign_mask {
  position: fixed;
  left: 50%;
  top: 50%;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 0px 11px 16px;
}

.sign_mask .sign_mask_image {
  width: 137px;
  height: 137px;
  display: block;
}

.sign_mask .sign_mask_text {
  font-size: 14px;
  color: #ffffff;
}
.task_content {
  justify-content: space-between;
  display: flex;
}
.tips {
  color: #aaaaaa;
  font-size: 12px;
  margin-top: 16px;
  text-align: center;
  display: block;
}
.task_content > span {
  border-bottom: 2px solid #ffffff;
  text-align: center;
  width: 50%;
  font-size: 16px;
  color: #aaaaaa;
  font-weight: bold;
  padding-bottom: 8px;
}

.task_content > .task-active {
  border-bottom: 2px solid #de3b34;
  color: #de3b34;
}
</style>



// WEBPACK FOOTER //
// src/components/bookTask.vue